import { axiosInstance } from "../../utility/apiInstance";

const BASE_URL = "/api/v1/custom-form";
const DROPDOWN_URL = "/api/v1/custom-form/field-types";

export const fetchFieldTypes = async () => {
  const res = await axiosInstance.get(DROPDOWN_URL);
  return res.data.data;
};

export const fetchCustomForms = async (search = "") => {
  const params = search.trim() ? { search } : {};
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data.data;
};

export const createCustomForm = async (payload: any, options: string[]) => {
  const res = await axiosInstance.post(BASE_URL, { ...payload, dropdownOptions: options });
  return res.data;
};

export const updateCustomForm = async (id: any, updates: any, options: string[]) => {
  const payload = { ...updates, dropdownOptions: options };
  const res = await axiosInstance.patch(`${BASE_URL}/${id}`, { ...payload, dropdownOptions: options });
  return res.data;
};

export const deleteCustomForm = async (id: any) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}`, { active: false });
  return res.data;
};